import { Link, NavLink } from "react-router-dom";
import { Truck, Menu, X, Phone } from "lucide-react";
import { useState } from "react";

const links = [
  { to: "/", label: "Accueil" },
  { to: "/villes", label: "Nos villes" },
  { to: "/blog", label: "Blog" },
  { to: "/devis", label: "Demander un devis" },
  { to: "/a-propos", label: "Comment ça marche" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  return (
    <header className="sticky top-0 z-40 bg-white/95 backdrop-blur-md border-b border-[#F0F2F5]">
      <nav className="container mx-auto px-6 lg:px-10 py-4 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2.5 group" data-testid="logo-link">
          <div className="w-10 h-10 bg-[#2BD391] rounded-full flex items-center justify-center shadow-[0_4px_14px_rgba(43,211,145,0.35)] group-hover:rotate-[-8deg] transition-transform">
            <Truck className="w-5 h-5 text-white" strokeWidth={2.2} />
          </div>
          <div className="leading-tight">
            <div className="font-heading font-extrabold text-lg tracking-tight">Déménageur <span className="text-[#2BD391]">Pro</span></div>
            <div className="text-[10px] uppercase tracking-[0.22em] text-[#6B7280] -mt-0.5">Votre déménagement, en toute confiance</div>
          </div>
        </Link>

        <div className="hidden lg:flex items-center gap-8">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-${l.to.replace("/", "") || "home"}`}
              className={({ isActive }) =>
                `text-sm font-semibold transition-colors hover:text-[#2BD391] ${
                  isActive ? "text-[#2BD391]" : "text-[#2C3E50]"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <a href="tel:+33185117296" className="hidden xl:flex items-center gap-2 text-sm font-semibold text-[#2C3E50] hover:text-[#2BD391]">
            <Phone className="w-4 h-4" /> 01 85 11 72 96
          </a>
          <Link
            to="/devis"
            className="btn-primary"
            data-testid="cta-devis-navbar"
          >
            Devis gratuits
          </Link>
        </div>

        <button
          className="lg:hidden p-2 rounded-full hover:bg-[#F7F9FB]"
          onClick={() => setOpen(!open)}
          data-testid="mobile-menu-btn"
          aria-label="Menu"
        >
          {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
        </button>
      </nav>
      {open && (
        <div className="lg:hidden border-t border-[#F0F2F5] bg-white px-6 py-5 space-y-3">
          {links.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              onClick={() => setOpen(false)}
              className="block text-sm font-semibold py-2 text-[#2C3E50]"
              data-testid={`nav-mobile-${l.to.replace("/", "") || "home"}`}
            >
              {l.label}
            </Link>
          ))}
          <Link
            to="/devis"
            onClick={() => setOpen(false)}
            className="btn-primary w-full"
            data-testid="cta-devis-mobile"
          >
            Devis gratuits
          </Link>
        </div>
      )}
    </header>
  );
};
